<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { HeartIcon, BellIcon, VideoCameraIcon } from '@heroicons/vue/24/solid'
import SolidHammer from '@/Components/Icons/SolidHammer.vue'
import HeaderCounter from './HeaderCounter.vue'
import MessagesDropdown from '@/Components/Header/Messages/MessagesDropdown.vue'
import { useHeaderCounters } from '@/Composables/useHeaderCounters'

const props = defineProps({
  cart: {
    type: Object,
    required: false,
  },
})

const { counter } = useHeaderCounters()

const userLoggedIn = computed(() => {
  return usePage().props.auth !== null
})

const headerCounters = computed(() => {
  return [
    {
      href: route('events.index'),
      icon: VideoCameraIcon,
      counter: __('new'),
      title: __('Live Events'),
      enabled: usePage().props.header.features['live-events-public'] && userLoggedIn.value,
    },
    {
      href: route('account.item-watch'),
      counter: counter('item_watch'),
      icon: HeartIcon,
      title: __('Item Watch'),
      enabled: userLoggedIn.value,
    },
    {
      href: route('account.current-bids'),
      counter: counter('current_bids'),
      icon: SolidHammer,
      title: __('Current Bids'),
      enabled: userLoggedIn.value,
    },
    {
      href: route('account.notifications.index'),
      counter: counter('notifications'),
      icon: BellIcon,
      title: __('Notifications'),
      position: 'top-0',
      enabled: userLoggedIn.value,
      inertia: true,
    },
    props.cart,
  ]
})
</script>

<template>
  <div
    class="flex items-center text-gray-600 gap-3 lg:gap-4"
  >
    <MessagesDropdown />
    <HeaderCounter
      v-for="counter in headerCounters"
      :key="counter.title"
      class="hover:underline"
      v-bind="counter"
    />
  </div>
</template>
